import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBar from '~/components/dashboard/SearchBar';
import axios from '~/plugins/axios';

export default {
  name: 'EditUserPanel',
  components: {
    SearchBar: SearchBar
  },
  data: function data() {
    return {
      userEditedList: [],
      userEditedListTable: {
        fullName: {
          key: 'fullname',
          label: 'Applicant Name'
        },
        nricFin: {
          key: 'nricFin',
          label: 'Nric / Fin'
        },

        flag: {
          key: 'flag',
          label: 'Acc. Type'
        },
        companyName: {
          key: 'companyName',
          label: 'companyName',
          sortable: true
        },
        actions: {
          key: 'actions',
          label: 'Actions'
        }
      }
    };
  },

  methods: {
    getSearchResult: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var searchKey = _ref.searchKey,
            searchContent = _ref.searchContent;
        var tuserEditedList, nricFin, user, companyName, fullname;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('\n\n ======== EditUserPanel <|-- received data =======\n Search Key: ', searchKey, '\n Search Content :', searchContent, '\n ============');

                tuserEditedList = [];

                if (!(searchKey == 'Nric/Fin')) {
                  _context.next = 15;
                  break;
                }

                console.log('\n\n ===== EditUserPanel <|-- NricFin branch====== \n');

                nricFin = searchContent.trim();
                _context.next = 7;
                return axios.post('/users/nricFin', { nricFin: nricFin });

              case 7:
                _context.t0 = _context.sent.data;

                if (_context.t0) {
                  _context.next = 10;
                  break;
                }

                _context.t0 = ['User Not Found'];

              case 10:
                user = _context.t0;


                console.log('\n\n ===== EditUserPanel <|-- NricFin branch====== \n', user, '\n -------------------------------');

                tuserEditedList.push(user);
                _context.next = 40;
                break;

              case 15:
                if (!(searchKey == 'Company')) {
                  _context.next = 27;
                  break;
                }

                console.log('\n\n ===== EditUserPanel <|-- Company branch ====== \n');

                companyName = searchContent.trim();
                _context.next = 20;
                return axios.post('/users/companyName', {
                  companyName: companyName
                });

              case 20:
                _context.t1 = _context.sent.data;

                if (_context.t1) {
                  _context.next = 23;
                  break;
                }

                _context.t1 = ['User Not Found'];

              case 23:
                tuserEditedList = _context.t1;


                console.log('\n\n ===== EditUserPanel <|-- Company branch ====== \n', tuserEditedList, '\n ------------------------------');
                _context.next = 40;
                break;

              case 27:
                if (!(searchKey == 'Full Name')) {
                  _context.next = 39;
                  break;
                }

                console.log('\n\n ===== EditUserPanel <|-- Full Name branch====== \n');
                fullname = searchContent.trim();
                _context.next = 32;
                return axios.post('/users/fullName', { fullname: fullname });

              case 32:
                _context.t2 = _context.sent.data;

                if (_context.t2) {
                  _context.next = 35;
                  break;
                }

                _context.t2 = ['User Not Found'];

              case 35:
                tuserEditedList = _context.t2;


                console.log('\n\n ===== EditUserPanel <|-- Full Name branch====== \n', tuserEditedList, '\n ------------------');
                _context.next = 40;
                break;

              case 39:
                alert('Error Key');

              case 40:
                this.userEditedList = tuserEditedList == 'User Not Found' || !tuserEditedList ? alert('User Not Found') : tuserEditedList;

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSearchResult(_x) {
        return _ref2.apply(this, arguments);
      }

      return getSearchResult;
    }(),
    editUser: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(user, index, btn) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('User: ', user);
                console.log('Index: ', index);
                console.log('Btn: ', btn);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function editUser(_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return editUser;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/EditUserPanel.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/EditUserPanel.vue
// module chunks = 0